import http from "../../http-common"

class PressReleasesService {
    getAllPressReleases() {
        return http.get(`/who-we-are/press-releases`)
    }  
}

export default new PressReleasesService();